import styled, { css } from 'styled-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';

export {
  TransactionDate,
  TransactionDateAndTime,
  TransactionTime,
} from '../loyalty-history/loyalty-history.styled';

export const PurchaseAmount = styled.div`
  display: flex;
  justify-content: flex-end;
  font-weight: ${Styles.fontWeight.normal};
`;

export const Rewards = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const Reward = styled.div`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1rem;
  color: ${Styles.color.black};
  display: flex;
  flex-direction: column;
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  width: 1rem;
`;

export const PointsText = styled.div<{ $pointsEarned?: boolean }>`
  font-size: 1rem;
  margin-left: 0.25rem;
  color: ${Styles.color.rewardRedeemText} !important;
  font-weight: ${Styles.fontWeight.heavy};
  ${props =>
    props.$pointsEarned &&
    css`
      color: ${Styles.color.rewardEarnText} !important;
    `}
`;

export const IconWrapper = styled.div<{ $pointsEarned: boolean }>`
  display: flex;
  align-items: center;
`;

export const PointsLineWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.625rem;
  }
`;

export const PointsDescription = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.8125rem;
  font-weight: ${Styles.fontWeight.normal};
`;
